const AJOUT_RESEAU_LC = {
  title: 'Ajouter un réseau LC',
  racine: 'Accueil',
  location: 'Location : {location}',
  periode: 'du {dateDebut} au {dateFin}',
  brief: 'Mon brief',
  panier: 'Panier',
  actions: {
    back: 'Retour',
    search: 'Rechercher',
  },
  table: {
    codeReseau: 'Code réseau',
    libelle: 'Libellé',
    type: 'Type',
    zipCode: 'CP',
    city: 'Ville',
    format: 'Format',
    societe: 'Société',
  },
  errors: {
    datesRequired: 'La date de début et la date de fin sont obligatoires.',
    produitLoc: 'Le produit de location est obligatoire.',
    produitDefaultLoc: 'Aucun produit de location par défaut n\'est lié au réseau',
    errorProduitLocationNotFound: 'Impossible de trouver le produit de location dans la société',
    dateDebutGreaterDateFin: 'La date de début est plus grande que la date de fin.',
    problemOccurred: 'Un problème est survenu',
  },
  briefContent: {
    brief: 'Mon brief',
    appliquerBrief: 'Appliquer les paramètres de votre brief',
    locationDefault: 'Produit location par défaut',
    au: 'au',
    periode: 'Période',
    location: 'Location',
    reseauConfrere: 'Inclure réseaux confrères',
    codeReseau: 'Code(s) réseau',
    villes: 'Ville(s) réseau',
    departements: 'Département',
    libelle: 'Libellé',
    formats: 'Format',
    appliquer: 'Appliquer',
    reinitialiser: 'Réinitialiser',
    budgetMax: 'Budget max',
    societe: 'Société',
  },
  panierContent: {
    panier: 'Panier',
    sousTitle: '{numberProduit} produits dans votre panier',
    panierVide: 'Votre panier est vide',
    total: 'Total',
    reseauPerso: 'Créer un réseau personnalisé',
    noProduct: 'Sélectionnez des produits',
    add: 'Ajouter',
    datePeriode: 'Du {dateDebut} au {dateFin}',
    noNewProduct: 'Aucun produit ajouté via l\'écran de sélection',
    produitFromDCF: 'Produit(s) présent(s) dans {typeDCF}',
    newSelection: 'Nouvelle sélection',
    clearSelection: 'Vider ma sélection',
    type: {
      devis: 'le devis',
      commande: 'la commande',
      facture: 'la facture',
    },
  },
};

export default AJOUT_RESEAU_LC;
